<template>
  <!-- 登录页全屏独立展示,不套后台布局 -->
  <router-view v-if="isPublic" />

  <template v-else>
    <el-container class="layout">
      <!-- 桌面端:左侧固定菜单 -->
      <el-aside v-if="!isMobile" width="220px" class="aside">
        <SideMenu />
      </el-aside>

      <el-container>
        <!-- 顶部栏 -->
        <el-header class="header" :height="isMobile ? '50px' : '60px'">
          <div class="header-left">
            <!-- 移动端:点击展开抽屉菜单 -->
            <el-icon v-if="isMobile" class="menu-btn" @click="menuVisible = true">
              <Expand />
            </el-icon>
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item v-if="$route.meta.title">{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="user">
            <span v-if="!isMobile">{{ currentUserName }}（{{ isAdminUser ? '管理员' : '普通用户' }}）</span>
            <span class="logout" @click="handleLogout">退出登录</span>
          </div>
        </el-header>

        <el-main class="main" :class="{ 'main-mobile': isMobile }">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <!-- 移动端:抽屉式菜单 -->
    <el-drawer
      v-model="menuVisible"
      direction="ltr"
      size="220px"
      :with-header="false"
      class="menu-drawer"
    >
      <SideMenu />
    </el-drawer>
  </template>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Expand } from '@element-plus/icons-vue'
import SideMenu from '@/components/SideMenu.vue'
import { getUser, clearAuth } from '@/api/auth'

// 屏幕宽度小于该值时按移动端处理
const MOBILE_MAX_WIDTH = 768

const route = useRoute()
const router = useRouter()
const isMobile = ref(window.innerWidth <= MOBILE_MAX_WIDTH)
const menuVisible = ref(false)

const syncIsMobile = () => {
  isMobile.value = window.innerWidth <= MOBILE_MAX_WIDTH
}

onMounted(() => window.addEventListener('resize', syncIsMobile))
onBeforeUnmount(() => window.removeEventListener('resize', syncIsMobile))

// 跳转后收起移动端菜单
watch(() => route.fullPath, () => (menuVisible.value = false))

// 登录等公开页面无需菜单布局
const isPublic = computed(() => !!route.meta.public)

// 顶部展示当前登录用户及其类型
const currentUser = computed(() => getUser() || {})
const currentUserName = computed(() => currentUser.value.username || '未登录')
const isAdminUser = computed(() => currentUser.value.userType === 'ADMIN')

const handleLogout = () => {
  clearAuth()
  menuVisible.value = false
  router.push('/login')
}
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>

<style scoped>
.layout {
  height: 100%;
}
.aside {
  background-color: #001529;
  overflow-y: auto;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
}
.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
}
.menu-btn {
  margin-right: 12px;
  font-size: 20px;
  color: #606266;
  cursor: pointer;
}
.user {
  flex-shrink: 0;
  color: #606266;
  font-size: 14px;
}
.logout {
  margin-left: 12px;
  color: #409eff;
  cursor: pointer;
}
.main {
  background: #f5f7fa;
}
/* 移动端减小内容区内边距 */
.main-mobile {
  padding: 10px;
}
</style>

<style>
/* 移动端抽屉菜单:去掉默认内边距,让菜单铺满 */
.menu-drawer .el-drawer__body {
  padding: 0;
}
/* 小屏下面包屑不换行溢出 */
@media (max-width: 768px) {
  .header .el-breadcrumb {
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
  }
  .header .user .logout {
    margin-left: 0;
  }
}
</style>
